module.exports = __webpack_public_path__ + "img/logo.f9307fe1.png";